module.exports = __webpack_public_path__ + "img/patch-question-fill.5d9de558.svg";